import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import api from "./api/axios";
import { CircleQuestionMark } from "lucide-react";
import { LogOut } from "lucide-react";

export default function AdminSidebar() {
  const location = useLocation();
  const navigate = useNavigate();

  const menuItems = [
    { name: "Video Edukasi", path: "/admin/video" },
    { name: "Artikel Edukasi", path: "/admin/article" },
    { name: "Komunitas Online", path: "/admin/community" },
    { name: "Faskes & Dokter", path: "/admin/faskes" },
    { name: "Admin", path: "/admin/adminList" },
    { name: "User", path: "/admin/userList" },
    { name: "Kategori", path: "/admin/category" },
    { name: "Pendamping", path: "/admin/caregiver-patient" },
  ];

  const handleLogout = async () => {
    try {
      await api.post("/logout");
    } catch (err) {
      console.error("Logout failed", err);
    }
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    navigate("/admin/login");
  };

  return (
    <div className="w-60 bg-white border-r p-4 flex flex-col justify-between">
      <div>
        <img src="/logohallostroke.png" alt="Logo" className="h-12 mb-6" />
        <nav className="space-y-1">
          {menuItems.map((item) => {
            const isActive = location.pathname.startsWith(item.path);
            return (
              <Link
                key={item.name}
                to={item.path}
                className={`block w-full text-left px-3 py-2 rounded ${
                  isActive
                    ? "bg-blue-50 text-blue-600 border-l-4 border-blue-600 font-medium"
                    : "text-gray-700 hover:bg-gray-100"
                }`}
              >
                {item.name}
              </Link>
            );
          })}
        </nav>
      </div>
      <div className="space-y-2 ">
        <a
          className="flex items-center gap-2 pb-3 text-gray-700 hover:text-blue-600"
          href="https://docs.google.com/document/d/1k66pCvr9UM8DHudmUvpdrxPi3idFDqoBLjGs9i3jF1g/edit?tab=t.0"
          target="_blank"
          rel="noopener noreferrer"
        >
          <CircleQuestionMark />
          Bantuan
        </a>
        <button
          className="flex items-center gap-2 text-red-500 hover:text-red-700"
          onClick={handleLogout}
        >
          <LogOut />
          Logout
        </button>
      </div>
    </div>
  );
}
